import disciplinaryAction from '@/api/disciplinary-action'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  ac_status_id: 1,
  ac_year_id: undefined,
  disciplinary_subject_id: undefined,
  branch_id: undefined,
  date_from: moment()
    .add(-1, 'Month')
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, data) {
    state.date_from = data
  },
  SET_DATE_TO(state, data) {
    state.date_to = data
  },
  SET_YEAR_ID(state, data) {
    state.ac_year_id = data
  },
  SET_DISCIPLINARY_SUBJECT_ID(state, data) {
    state.disciplinary_subject_id = data
  },
  SET_AC_STATUS(state, acStatusId) {
    state.ac_status_id = acStatusId
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ac_year_id: context.state.ac_year_id,
        disciplinary_subject_id: context.state.disciplinary_subject_id,
        branch_id: context.state.branch_id,
        date_range: [context.state.date_from, context.state.date_to]
      },
      attrubutes
    )
    return disciplinaryAction.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return disciplinaryAction.store(data)
  },
  update(context, data) {
    return disciplinaryAction.update(data)
  },
  destroy(context, id) {
    return disciplinaryAction.destroy(id)
  },
  getDisciplinarySubject(context, data) {
    return disciplinaryAction.disciplinarySubject(data)
  },
  getSubjectType(context, data) {
    return disciplinaryAction.subjectType(data)
  },
  getBranch(context, data) {
    return disciplinaryAction.branch(data)
  },
  previewPdf(context, data) {
    return disciplinaryAction.previewPdf({
      params: {
        disciplinary_id: data.disciplinary_id,
        student_id: data.student_id,
        card_type: data.card_type
      }
    })
  }
}
